import axios from "axios";
import AuthService from "./authentication.service";

const { REACT_APP_API_BASE_URL } = process.env;

const https = axios.create({
  baseURL: REACT_APP_API_BASE_URL,
  timeout: 60000,
  headers: { "Content-Type": "application/json" },
});

export const setupInterceptor = () => {
  https.interceptors.request.use((config) => {
    const token = AuthService.getAccessToken();
    config.headers.Authorization = `Bearer ${token}`;
    config.baseURL = REACT_APP_API_BASE_URL;
    return config;
  });

  https.interceptors.response.use(
    (response) => {
      if (!response?.data) {
        const errMessages = response?.data?.messages?.join("");
        return errMessages;
      } else {
        return response;
      }
    },
    (error) => {
      if (navigator.onLine) {
        handleException(error);
      }
      //  return Promise.reject(error);
    }
  );

  const handleException = async (error) => {
    if (error?.response?.status === 401) {
      AuthService.logout();
    }
    // return Promise.reject(error);
  };
};

export default https;
